import * as defaultImport from "@splunk/visualizations/Timeline";
export * from "@splunk/visualizations/Timeline";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
